import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedAccountLogActions} from 'src/openapi/admin/apis/AuditLogDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useGetAccountLogActionDictionary = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSupportedAccountLogActions({accountId}),
    ), [apiDispatch, accountId]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
